import { LogCannon } from '@ace-clublabs/log-cannon';
import Cookies from 'universal-cookie';
import { TOKEN_KEY_PAYMENTS } from '../constants';

export const createAxiosConfig = (scenario: string | null | undefined, endpoint: string) => {
  let headers: any = {
    'X-Ace-Session-Id': LogCannon.getSessionId(),
  };
  const timeZone = (() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';
    } catch {
      return 'America/Los_Angeles';
    }
  })();
  headers = { ...headers, 'X-Ace-Time-Zone': timeZone };
  const cookies = new Cookies();
  const authToken = cookies.get(TOKEN_KEY_PAYMENTS);
  if (authToken) {
    headers = { ...headers, Authorization: `Bearer ${authToken}` };
  }

  const isProd = endpoint.search('common.api.ace.aaa.com') > -1;
  if (isProd || !scenario) {
    return {
      headers,
    };
  }
  return {
    headers: {
      ...headers,
      'X-Ace-Mock': scenario ? 'true' : 'false',
      'X-Ace-Test-Scenario': scenario ? scenario : undefined,
    },
  };
};
